import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import {
    removeGroupRoleChildFromModeling,
    addGroupRoleChildToModeling,
    selectModelingUsers,
    setSelectedUserRole,
    expandGroupRole,
    addModelingSelectedUserRole,
    deleteModelingSelectedUserRole,
    restoreDeletedRole,
    selectModelingSystemId,
} from "../../../reducers/reports-modeling/userLevelSlice";

import GroupRoleModelingBox from "../group-role-modeling-box";
import { integrationService } from "../../../services/integration-service";
import { nanoid } from "@reduxjs/toolkit";

const UserLevelGroupRoleModelingBox = ({ selectedRole }) => {
    const dispatch = useDispatch();
    const [rows, setRows] = useState([]);
    const roles = useSelector(selectModelingUsers)[0]?.roles;
    const systemId = useSelector(selectModelingSystemId);
    const isAddDisabled = selectedRole?.isComplex ? selectedRole.isStandard : selectedRole?.isStandard && selectedRole?.isChild;
    const isDeleteDisabled = !selectedRole || selectedRole?.status == "deleted" || selectedRole.isStandard;
    const isAddUserRole = !selectedRole?.isComplex && !selectedRole?.isChild;
    const isDeleteUserRole = !selectedRole?.isChild;

    // const handleAddChildRole = (newChildRole) => {
    //     dispatch(
    //         addGroupRoleChildToModeling({
    //             roleId: selectedRole.id,
    //             newChildRole
    //         })
    //     );
    //     handleExpandChildrenRoles(selectedRole, true)
    // }

    const handleAddRole = (newRole = {}) => {
        if (selectedRole?.status == "deleted") {
            dispatch(restoreDeletedRole({ roleId: selectedRole.id }));
            dispatch(setSelectedUserRole(null));
            return;
        }
        if (!selectedRole?.isComplex && !selectedRole?.isChild) {
            dispatch(addModelingSelectedUserRole(newRole));
        } else {
            dispatch(
                addGroupRoleChildToModeling({
                    roleId: selectedRole?.isChild ? selectedRole?.parentRole : selectedRole?.role,
                    newChildRole: newRole,
                })
            );
            handleExpandChildrenRoles(selectedRole);
        }
    };

    const handleRemoveChildRoles = () => {
        dispatch(
            removeGroupRoleChildFromModeling({
                role: selectedRole,
            })
        );
        dispatch(setSelectedUserRole(null));
    };

    const handleRemoveUserRole = () => {
        dispatch(deleteModelingSelectedUserRole(selectedRole.id));
        dispatch(setSelectedUserRole(null));
    };

    const handleRowClick = (row, setActiveRow) => {
        dispatch(setSelectedUserRole(row));
        setActiveRow(row.id);
    };

    const handleExpandChildrenRoles = (row) => {
        dispatch(setSelectedUserRole(row));
        dispatch(expandGroupRole({ role: row }));
    };

    useEffect(() => {

        if (!roles) {
            setRows([]);
            return;
        }

        const rows = [];

        roles.forEach((role) => {
            rows.push({
                ...role,
                localId: nanoid()
            });
            if (role.isComplex && role.open) {
                role.children.forEach((childrenRole) => {
                    rows.push({
                        ...childrenRole,
                        localId: nanoid(),
                    });
                });
            }
        });

        setRows(rows);
    }, [roles]);

    const getRoles = useCallback(
        (params, signal) => {
            if (params && params["filters"]) {
                params["filters"].push({ field: "systemId", sign: "EQ", value: systemId });
            }

            return integrationService.getModelingRoles(params, signal);
        },
        [systemId]
    );

    return (
        <GroupRoleModelingBox
            roles={rows}
            selectedRole={selectedRole}
            onAddChildRole={handleAddRole}
            onRemoveChildRoles={isDeleteUserRole ? handleRemoveUserRole : handleRemoveChildRoles}
            handleRowClick={handleRowClick}
            handleExpandChildrenRoles={handleExpandChildrenRoles}
            isAddDisabled={isAddDisabled}
            isDeleteDisabled={isDeleteDisabled}
            showSingleRoles={!isAddUserRole}
            getRoles={getRoles}
        />
    );
};

UserLevelGroupRoleModelingBox.propTypes = {
    selectedRole: PropTypes.object,
};

export default UserLevelGroupRoleModelingBox;
